import React , { useCallback,useEffect,useState,useContext } from 'react';
import { Table,Spin,Input,Modal,Button,message,Select,InputNumber,Popover} from 'antd';
import PlayerCard from './PlayerCard';
import _ from "lodash";
import { APIrequest } from '../../Helpers.js'
import { parseRules } from './Scoring'
import { UserContext } from "../../Contexts/UserContext";
// import { useReactToPrint } from 'react-to-print';
function Projections (props) {
    const { userID } =
    useContext(UserContext);
    const { Option } = Select;
    const [teams, setTeams] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [projections, setProjections] = useState([]);
    const [projectionsLoading, setProjectionsLoading] = useState(false);
    const [team, setTeam] = useState(null);
    const [PFFdata, setPFFdata] = useState([]);
    const [PFFteamData, setPFFteamData] = useState([]);
    const [myLeagues, setMyLeagues] = useState([]);
    const [scoringLoading, setScoringLoading] = useState(false);
    const [scoringLeague, setScoringLeague] = useState(null);
    const [sorter, setSorter] = useState("PPG");
    const [scoring, setScoring] = useState({"QB":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"RB":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"WR":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0},"TE":{"Passing Yards":0,"Number of Passing TDs":0,"Rushing Yards":0,"Number of Rushing TDs":0,"Receptions":0,"Receiving Yards":0,"Number of Receiving TDs":0}});
    const calculateProjections = async (projection)=>{
      const {  PassingPlays =0,RushingPlays=0} = teamData?.find(f => f.NFL_TeamID ===projection.NFL_TeamID)||{}
     projection.PassingAttempts=Math.round(PassingPlays*projection.PassAttemptRate/100*100)/100
     projection.CompletionPercentage=Math.round(projection.XCompletionPercentage*projection.CompletionPercentageFactor/100*100)/100
     projection.YardsPerCompletion=Math.round(projection.XYardsPerCompletion*projection.YardsPerCompletionFactor/100*100)/100
     projection.YardsPerAttempt=Math.round(projection.CompletionPercentage*projection.YardsPerCompletion/100*100)/100
     projection.Yards=Math.round(projection.YardsPerAttempt*projection.PassingAttempts*100)/100
     projection.PassingTouchdownRate=Math.round(projection.XPassingTouchdownRate*projection.PassingTouchdownRateFactor/100*100)/100
     projection.InterceptionRate=Math.round(projection.XInterceptionRate*projection.InterceptionRateFactor/100*100)/100
     projection.PassingTouchdowns=Math.round(projection.PassingTouchdownRate*projection.PassingAttempts/100*100)/100
     projection.Interceptions=Math.round(projection.InterceptionRate*projection.PassingAttempts/100*100)/100
     projection.Routes=Math.round(projection.RouteParticipation*PassingPlays/100*100)/100
     projection.Targets=Math.round(projection.Routes*projection.TargetsPerRouteRun/100*100)/100;
     projection.TargetShare=Math.round(projection.Targets/projections.filter((p)=>p.Position==='QB').map(p=>p.PassingAttempts).reduce((pv, cv) => pv + cv, 0)*10000)/100
     projection.CatchRate=Math.round(projection.XCatchRate*projection.CatchRateFactor/100*100)/100
     projection.Receptions=Math.round(projection.CatchRate*projection.Targets/100*100)/100
     projection.YardsPerCatch=Math.round(projection.XYardsPerCatch*projection.YardsPerCatchFactor/100*100)/100
     projection.YardsPerTarget=Math.round(projection.CatchRate*projection.YardsPerCatch/100*100)/100
     projection.ReceivingYards=Math.round(projection.YardsPerTarget*projection.Targets*100)/100
     projection.ReceivingTouchdownRate=Math.round(projection.XReceivingTouchdownRate*projection.ReceivingTouchdownRateFactor/100*100)/100
     projection.ReceivingTouchdowns=Math.round(projection.ReceivingTouchdownRate*projection.Targets/100*100)/100
     projection.Carries=Math.round(projection.CarryShare*RushingPlays/100*100)/100
     projection.YardsPerCarry=Math.round(projection.XYardsPerCarry*projection.YardsPerCarryFactor/100*100)/100
     projection.RushingTouchdownRate=Math.round(projection.XRushingTouchdownRate*projection.RushingTouchdownRateFactor/100*100)/100
     projection.RushingYards=Math.round(projection.Carries*projection.YardsPerCarry*100)/100
     projection.RushingTDs=Math.round(projection.RushingTouchdownRate*projection.Carries/100*100)/100
        return projection
      }
    const getTeams = async ()=>{
        console.log("Fetching teams")
        fetch(`/api/db/getNFLTeams`,{
            headers : { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {console.log(data.response);setTeams(data.response);
        });
      }
      const calcPoints=(data)=>{
        const receptionPts= data.Position==='WR'?1.25:(data.Position==='TE'?1.75:1)
        const PointsPer10= (data.Position==='TE'?1.5:1)
        console.log("scoring",scoring)
        return (Math.round((
            data.Yards*scoring[data.Position]["Passing Yards"]+
            data.PassingTouchdowns*scoring[data.Position]["Number of Passing TDs"]+
            data.Interceptions*scoring[data.Position]["Pass Interceptions Thrown"]+
            data.Receptions*scoring[data.Position]["Receptions"]+
            data.ReceivingYards*scoring[data.Position]["Receiving Yards"]+
            data.ReceivingTouchdowns*scoring[data.Position]["Number of Receiving TDs"]+
            data.RushingTDs*scoring[data.Position]["Number of Rushing TDs"]+
            data.RushingYards*scoring[data.Position]["Rushing Yards"])*100)/100)
    }
    const getProjections = async ()=>{
        setProjectionsLoading(true)
        fetch(`/api/db/getProjections/${userID}/2022/${team?team:''}`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setProjections(data.response);setProjectionsLoading(false)
        });
      }
      const getTeamData = async ()=>{
        fetch(`/api/db/getTeamPlays/${userID}/2022`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setTeamData(data.response);
        });
      }
      const getPFFData = async ()=>{
        console.log("Fetching Projections")
        fetch(`/api/db/getPFF/${userID}/2022`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setPFFdata(data.response);
        });
      }
      const getMyLeagues = async ()=>{
        const result=await APIrequest(`/api/mfl/myLeagues`)
        .then(data => {setMyLeagues([...data.leagues.league,{league_id:5,name:'Half-PPR'}]);setScoringLeague(data.leagues.league[0]["league_id"]);
        });
      }
      const getLeagueRules = async (L)=>{
        if (L)
        {
          if (L==5)
          {
            setScoring({"QB":{"Passing Yards":0.04,"Number of Passing TDs":4,"Rushing Yards":0.1,"Number of Rushing TDs":6,"Receptions":0.5,"Receiving Yards":0.1,"Number of Receiving TDs":6,"Pass Interceptions Thrown":-1},"RB":{"Passing Yards":0.04,"Number of Passing TDs":6,"Rushing Yards":0.1,"Number of Rushing TDs":6,"Receptions":0.5,"Receiving Yards":0.1,"Number of Receiving TDs":6,"Pass Interceptions Thrown":-1},"WR":{"Passing Yards":0.05,"Number of Passing TDs":6,"Rushing Yards":0.1,"Number of Rushing TDs":6,"Receptions":0.5,"Receiving Yards":0.1,"Number of Receiving TDs":6,"Pass Interceptions Thrown":0},"TE":{"Passing Yards":0.05,"Number of Passing TDs":6,"Rushing Yards":0.1,"Number of Rushing TDs":6,"Receptions":0.5,"Receiving Yards":0.1,"Number of Receiving TDs":6,"Pass Interceptions Thrown":0}})
          }
          else{
            setScoringLoading(true)
          await APIrequest(`/api/mfl/getLeagueRules?L=${L}`)
          .then(data => {setScoring(parseRules(data.rules.positionRules));setScoringLoading(false);
          });
          }
          
        }

      }
      const getPFFTeamData = async ()=>{
        fetch(`/api/db/getTeamPFF/${userID}/2022`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }})
        .then(data => data.json())
        .then(data => {setPFFteamData(data.response);
        });
      }
    useEffect(()=> {
        getTeams();
        getMyLeagues();
        getPFFData();
        getPFFTeamData();
        getTeamData();
    } ,[]);

    useEffect(()=> {
        getProjections();
    } ,[]);

    useEffect(()=> {
        getLeagueRules(scoringLeague)
    } ,[scoringLeague]);
      
    const saveProjection = async (projection)=>{
      
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(projection)
    };
    return await fetch(`/api/db/saveProjection/${userID}`,requestOptions)
  }
    const saveTeamProjection = async (projection)=>{
      
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(projection)
      };
      return await fetch("/api/db/saveTeamProjection/1",requestOptions)
    }

    const teamPopoverContent=(stat,Percent)=>(
      <div className='flexcol'>
          {PFFteamData.filter(d=>!d.Position && d.NFL_TeamID===team).sort((a,b)=> (a.Year - b.Year || a.week - b.week )).map(d=><div className='flexrow'><div style={{width:'80px'}}>{d.week||`${d.Year}(${d.Games})`}</div><div>{d[stat]}{Percent?'%':''}</div></div>)}
      </div>
  )
  const teamPosPopoverContent=(pos,stat,Percent)=>(
    <div className='flexcol'>
        {PFFteamData.filter(d=>d.Position===pos && d.NFL_TeamID===team).sort((a,b)=> (a.Year - b.Year || a.week - b.week )).map(d=><div className='flexrow'><div style={{width:'80px'}}>{d.week||`${d.Year}(${d.Games})`}</div><div>{d[stat]}{Percent?'%':''}</div></div>)}
    </div>
)
  const teamPopoverDvisionContent=(pos,numerator,denomenator)=>(
    <div className='flexcol'>
        {PFFteamData.filter(d=>!d.Position && d.NFL_TeamID===team).sort((a,b)=> (a.Year - b.Year || a.week - b.week )).map(d=><div className='flexrow'><div style={{width:'80px'}}>{d.week||`${d.Year}(${d.Games})`}
        </div><div>{
            Math.round((PFFteamData.find(p=>((pos===''?p.Position:pos)===p.Position && p.week===d.week && p.NFL_TeamID===team && p.Year===d.Year))?PFFteamData.find(p=>((pos===''?p.Position:pos)===p.Position && p.NFL_TeamID===team && p.week===d.week && p.Year===d.Year))[denomenator]:0)/
        d[numerator]*100,2)/100
        }
        </div></div>)}
    </div>
)
// useEffect(()=> {
//     sortProjections();
    
// } ,[sorter,scoring,setScoringLoading]);
  
    const onProjectionChange= async (e,playerID,setting) => {
        const tempProjections=projections;
        const ind=tempProjections.findIndex((r)=>r.NFL_PlayerID===playerID)
        tempProjections[ind][setting]=e.target.value.replace('%', '')
        tempProjections[ind]= await calculateProjections(tempProjections[ind]).then(saveProjection(tempProjections[ind]))
        
        setProjections([...tempProjections])
    };

    const onTeamDataChange= async (e,setting) => {
      const tempTeamProjections=teamData
      const ind=tempTeamProjections.findIndex((r)=>r.NFL_TeamID===team)
      tempTeamProjections[ind][setting]=e.target.value.replace('%', '')
      const tempProjections=projections;
      saveTeamProjection(tempTeamProjections[ind]);
      setTeamData([...tempTeamProjections]);
      for (var p of tempProjections.filter(tp=>tp.Position==='QB' && tp.NFL_TeamID===team)) {
        p= await calculateProjections(p).then(saveProjection(p)).then(setProjections([...tempProjections]))
      }
      for (var p of tempProjections.filter(tp=>tp.Position!=='QB' && tp.NFL_TeamID===team)) {
        p= await calculateProjections(p).then(saveProjection(p)).then(setProjections([...tempProjections]))
      }
     
      
      
  };
  
  const onScoringLeagueChange= e => {
    setScoringLeague(e);
};

const onSorterChange= e => {

    setSorter(e);

    //setSearchWord(e.target.value)
};

const sortProjections = (projections) =>{
    return projections.sort((a,b)=>{
      if (sorter==='PPG')
      {
          return calcPoints(b)-calcPoints(a)
      }
      else{
        return b[sorter]-a[sorter]
      }

      })
  }

    const onTeamChange= e => {
        setTeam(e);

        //setSearchWord(e.target.value)
    };
    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    
    console.log('scoring',JSON.stringify(scoring) )

    return (
        <div>
            <div className='flexrow'>
        Select Team:  
            <Select
        size='small'
          mode="single"
          allowClear={true}
          style={{ width: '200px' }}
          value={team}
          onChange={(e)=>onTeamChange(e)}
          optionLabelProp="label"
        >
          {teams.map(b=>
          <Option value={b.NFL_TeamID} label={b.TeamName}>
              <div>{b.TeamName}</div>
          </Option>)}
        </Select>
        Sort by:
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '100px' }}
          value={sorter}
          onChange={(e)=>onSorterChange(e)}
          optionLabelProp="label"
        >
          {["FantasyCalcValue","PPG","PassingAttempts","Yards","PassingTouchdowns","Targets","Receptions","ReceivingYards",
          "ReceivingTouchdowns","Carries","RushingYards","RushingTDs"].map(b=>
          <Option value={b} label={b}>
              <div>{b}</div>
          </Option>)}
        </Select>
        Select League Scoring:  
        <Select
        size='small'
          mode="single"
          allowClear={false}
          style={{ width: '300px' }}
          value={scoringLeague}
          onChange={(e)=>onScoringLeagueChange(e)}
          optionLabelProp="label"
        >
          {myLeagues.map(b=>
          <Option value={b.league_id} label={b.name}>
              <div>{b.name}</div>
          </Option>)}
        </Select>
        </div>
        <div className='flexrow'>
        {team?
        <div className='flexrow'>
        <div className='flexcol blackborder'>
            <div  style={{textAlign:'center',width:'100%'}}> Team Plays  </div>
            <div className='flexrow'>
                <Popover content={teamPopoverContent('Dropbacks',false)}>
                    <div  style={{margin:'0px 10px'}}>
                        <div>Passing </div>
                        <InputNumber 
                            style={{width:'50px'}}
                            bordered={false}
                            min={0} max={100}
                        size='small' 
                        parser={value => value.replace('%', '')} 
                        value={teamData.find((td)=>td.NFL_TeamID===team)?teamData.find((td)=>td.NFL_TeamID===team).PassingPlays:0}  
                        onPressEnter={(e)=>onTeamDataChange(e,'PassingPlays')}  width="W10"
                        />
                    </div>
                </Popover>
                <Popover content={teamPopoverContent('Carries',false)}>
                    <div  style={{width:'50px'}}>
                        <div>Rushing</div>
                        <InputNumber 
                            style={{margin:'0px 10px'}}
                            bordered={false}
                            min={0} max={100}
                        size='small' 
                        parser={value => value.replace('%', '')} 
                        value={teamData.find((td)=>td.NFL_TeamID===team)?teamData.find((td)=>td.NFL_TeamID===team).RushingPlays:0}  
                        onPressEnter={(e)=>onTeamDataChange(e,'RushingPlays')}  width="W10"
                        />
                    </div>
                </Popover>
            </div>   
        </div>
        <div className='flexcol blackborder'> 
            <div  style={{textAlign:'center',width:'100%'}}> Receiving/Passing Recon  </div>
            <div className='flexrow'>
                <Popover content={teamPopoverContent('Targets',false)}>
                    <div  style={{margin:'0px 10px'}}>
                    <div>volume</div>
                    <div>{Math.round(projections.filter(p=>p.NFL_TeamID===team).map(p=>p.Targets).reduce((pv, cv) => pv + cv, 0)*10000/
                    projections.filter(p=>p.NFL_TeamID===team).map(p=>p.PassingAttempts).reduce((pv, cv) => pv + cv, 0))/100}% 
                    ({Math.round(projections.filter(p=>p.NFL_TeamID===team).map(p=>p.Targets).reduce((pv, cv) => pv + cv, 0)*100)/100}/{Math.round(projections.filter(p=>p.NFL_TeamID===team).map(p=>p.PassingAttempts).reduce((pv, cv) => pv + cv, 0)*100)/100}) </div>
                    </div>
                </Popover>
                <Popover content={teamPopoverContent('ReceivingYards',false)}>
                <div  style={{margin:'0px 10px'}}>
                <div>Yards </div>
                <div>{Math.round(projections.filter(p=>p.NFL_TeamID===team).map(p=>p.ReceivingYards).reduce((pv, cv) => pv + cv, 0)*100,0)/100}/
                {Math.round(projections.filter(p=>p.NFL_TeamID===team).map(p=>p.Yards).reduce((pv, cv) => pv + cv, 0)*100,0)/100}</div>
                </div>
                </Popover>
                <Popover content={teamPopoverContent('PassingTouchdowns',false)}>
                <div  style={{margin:'0px 10px'}}>
                <div>TDs </div>
                <div>{Math.round(projections.filter(p=>p.NFL_TeamID===team).map(p=>p.ReceivingTouchdowns).reduce((pv, cv) => pv + cv, 0)*100,0)/100}/
                {Math.round(projections.filter(p=>p.NFL_TeamID===team).map(p=>p.PassingTouchdowns).reduce((pv, cv) => pv + cv, 0)*100,0)/100}
                </div>
                </div>
                </Popover>
            </div>
        </div>
        <div className='flexcol blackborder'> 
            <div  style={{textAlign:'center',width:'100%'}}> TDs By Position  </div>
            <div className='flexrow'>  
                <Popover classname='flexcol centre pad' content={teamPosPopoverContent('WR','ReceivingTouchdowns',false)}>
                <div style={{margin:'0px 10px'}}>
                <div classname='pad'>WR</div>   
                <div classname='pad'>{Math.round((projections.filter(p=>p.Position==='WR'&&p.NFL_TeamID===team).map(p=>p.ReceivingTouchdowns).reduce((pv, cv) => pv + cv, 0))*100,0)/100} </div>
                </div>
                </Popover>
                <Popover content={teamPosPopoverContent('RB','ReceivingTouchdowns',false)}>
                <div  style={{margin:'0px 10px'}}>
                <div>RB</div>
                <div>{Math.round((projections.filter(p=>p.Position==='RB'&&p.NFL_TeamID===team).map(p=>p.ReceivingTouchdowns).reduce((pv, cv) => pv + cv, 0))*100,0)/100} </div>
                </div>
                </Popover>
                
                <Popover content={teamPosPopoverContent('TE','ReceivingTouchdowns',false)}>
                <div  style={{margin:'0px 10px'}}>
                <div>TE</div>
                <div>{Math.round((projections.filter(p=>p.Position==='TE'&&p.NFL_TeamID===team).map(p=>p.ReceivingTouchdowns).reduce((pv, cv) => pv + cv, 0))*100,0)/100} </div>
                </div>
                </Popover>
            </div>  
        </div>
        <div className='flexcol blackborder'> 
            <div  style={{textAlign:'center',width:'100%'}}> Routes By Position  </div>
            <div className='flexrow'>  
                <div  style={{margin:'0px 10px'}}>
                <Popover content={teamPopoverDvisionContent('','Dropbacks','Routes')}>
                <div>All </div>
                <div>{Math.round((projections.filter(p=>p.NFL_TeamID===team).map(p=>p.Routes).reduce((pv, cv) => pv + cv, 0)/
                (teamData.find((td)=>td.NFL_TeamID===team)?teamData.find((td)=>td.NFL_TeamID===team).PassingPlays:0))*100,0)/100} </div>
                </Popover>
                </div>
                <div  style={{margin:'0px 10px'}}>
                <Popover content={teamPopoverDvisionContent('WR','Dropbacks','Routes')}>
                <div>WR </div>
                <div>{Math.round((projections.filter(p=>p.Position==='WR'&&p.NFL_TeamID===team).map(p=>p.Routes).reduce((pv, cv) => pv + cv, 0)/
                (teamData.find((td)=>td.NFL_TeamID===team)?teamData.find((td)=>td.NFL_TeamID===team).PassingPlays:0))*100,0)/100} </div>
                </Popover>
                </div>
                <div  style={{margin:'0px 10px'}}>
                <Popover content={teamPopoverDvisionContent('RB','Dropbacks','Routes')}>
                <div>RB </div>
                <div>{Math.round((projections.filter(p=>p.Position==='RB'&&p.NFL_TeamID===team).map(p=>p.Routes).reduce((pv, cv) => pv + cv, 0)/
                (teamData.find((td)=>td.NFL_TeamID===team)?teamData.find((td)=>td.NFL_TeamID===team).PassingPlays:0))*100,0)/100} </div>
                </Popover>
                </div>
                <div  style={{margin:'0px 10px'}}>
                <Popover content={teamPopoverDvisionContent('TE','Dropbacks','Routes')}>
                <div>TE </div>
                <div>{Math.round((projections.filter(p=>p.Position==='TE'&&p.NFL_TeamID===team).map(p=>p.Routes).reduce((pv, cv) => pv + cv, 0)/
                (teamData.find((td)=>td.NFL_TeamID===team)?teamData.find((td)=>td.NFL_TeamID===team).PassingPlays:0))*100,0)/100} </div>
                </Popover>
                </div>
            </div>  
        </div>
        </div>:
        <div></div>
        }
        </div>
        <div className='flexrow'>
        <div className='flexcol'>
          <div className='positionBank'>
            <div className='positionBankTitle'>QB</div>
            {projectionsLoading?<Spin/>:
            sortProjections(projections).filter((p)=>p.Position==='QB'&&p.NFL_TeamID===(team||p.NFL_TeamID)).slice(0,30).map((p)=><PlayerCard scoring={scoring} proj={projections} scoringLoading={scoringLoading} data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
          <div className='positionBank'>
            <div className='positionBankTitle'>WR</div>
            {projectionsLoading?<Spin/>:
            sortProjections(projections).filter((p)=>p.Position==='WR'&&p.NFL_TeamID===(team||p.NFL_TeamID)).slice(0,45).map((p)=><PlayerCard scoring={scoring} proj={projections} scoringLoading={scoringLoading} data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
        </div>
        <div className='flexcol'>
          <div className='positionBank'> 
            <div className='positionBankTitle'>RB</div>
            {projectionsLoading?<Spin/>:
            sortProjections(projections).filter((p)=>p.Position==='RB'&&p.NFL_TeamID===(team||p.NFL_TeamID)).slice(0,45).map((p)=><PlayerCard scoring={scoring}  proj={projections} scoringLoading={scoringLoading} data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
          <div className='positionBank'>
            <div className='positionBankTitle'>TE</div>
            {projectionsLoading?<Spin/>:
            sortProjections(projections).filter((p)=>p.Position==='TE'&&p.NFL_TeamID===(team||p.NFL_TeamID)).slice(0,30).map((p)=><PlayerCard scoring={scoring} proj={projections} scoringLoading={scoringLoading} data={p} onChange={onProjectionChange} PFFdata={PFFdata.filter(d=>d.NFL_PlayerID===p.NFL_PlayerID).sort((a,b)=> (a.Year - b.Year || a.week - b.week ))}></PlayerCard>)}
          </div>
        </div>
        
        </div>
        </div>
        
        )
        
    }

    export default Projections;


